import Vue from 'vue';
import Axios from './axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

Vue.prototype.$http = Axios; // this.$http.<get/post/put/delete>
// Axios.defaults.baseURL = process.env.VUE_APP_BASE_URL; // set API url
// Axios.defaults.headers.common.Accept = 'application/json';
// Axios.defaults.headers.patch['Content-Type'] = 'application/merge-patch+json';

const token = localStorage.getItem('token');

if (token) {
  // if token exist set it to any request
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
} else {
  // else redirect to login page to get token
  router.push({ path: '/login' });
}

new Vue({
  router,
  store,
  vuetify,
  Axios,
  render: h => h(App),
}).$mount('#app');
